import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    standalone: false
})
export class ShellComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
